import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const BigBlueArrowLeft: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="26" viewBox="0 0 15 26" fill="none">
      <path d="M13.1579 -1.61042e-07L15 1.8525L3.71711 13L15 24.1475L13.1579 26L-7.70853e-07 13L13.1579 -1.61042e-07Z" fill="#3273E1" />
    </svg>
  </SvgWrapper>
)

